import React, { useEffect, useState } from "react";
import { ArrowUpRight, Newspaper } from "lucide-react";
import { getHeadline } from "../lib/api";

const HeadlineBanner = () => {
  const [item, setItem] = useState(null);

  useEffect(() => {
    getHeadline().then(setItem).catch(() => setItem(null));
  }, []);

  if (!item) return null;

  return (
    <a
      href={item.source_url}
      target="_blank"
      rel="noreferrer"
      data-testid="headline-banner"
      className="group block bg-[var(--ink)] text-[var(--cream)]"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-3 flex items-center gap-2.5 sm:gap-5">
        <span className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-[var(--olive)] px-2 sm:px-3 py-1 text-[11px] font-bold uppercase tracking-eyebrow">
          <Newspaper className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Today's Headline</span>
        </span>
        <span
          data-testid="headline-banner-title"
          className="min-w-0 flex-1 line-clamp-2 sm:line-clamp-1 text-[14px] sm:text-[15px] font-semibold group-hover:underline underline-offset-4"
        >
          {item.title}
        </span>
        <span
          data-testid="headline-banner-source"
          className="hidden sm:inline shrink-0 text-[12px] text-[var(--cream-2)] opacity-80"
        >
          {item.source} · {item.date}
        </span>
        <ArrowUpRight className="w-4 h-4 shrink-0 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </div>
    </a>
  );
};

export default HeadlineBanner;
